import React from 'react';
import './Wellness.less';
import { WellnessIcon } from '../Common/Icons/WellnessIcon';
import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';

const WellnessHeader = () => {
  const trans = useSelector(translator);
  return (
    <>
      <div className="wellness-header-container">
        <div className="wellness-header-icon-title">
          <div className="wellness-header-icon">
            <WellnessIcon style={{ fill: '#113E57', width: '32px', height: '35px' }} />
          </div>
          <div className="wellness-header">
            <div className="wellness-header-title">{trans('BIOMETRICS')}</div>
            <div className="wellness-header-subtitle">
              {trans('COMPLETEAHEALTHREADINGONACONNECTEDDEVICEANDITWILLAPPEARHEREFOREASYVIEWING')}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WellnessHeader;
